import { Routes, Route } from "react-router-dom";
import { ApolloProvider } from "@/providers/ApolloProvider";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "./pages/HomePage";
import BusinessPage from "./pages/BusinessPage";
import BranchPage from "./pages/BranchPage";
import RedirectPage from "./pages/RedirectPage";
import SharedFavoritesPage from "./pages/SharedFavoritesPage";
import PublicAppointmentSummaryPage from "./pages/PublicAppointmentSummaryPage";
import PublicAppointmentPaymentPage from "./pages/PublicAppointmentPaymentPage";
import PublicAppointmentReceiptPage from "./pages/PublicAppointmentReceiptPage";

function App() {
  return (
    <ApolloProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/redirect" element={<RedirectPage />} />
        <Route path="/favorites/:shareToken" element={<SharedFavoritesPage />} />
        <Route path="/b/:bookingId" element={<PublicAppointmentSummaryPage />} />
        <Route path="/pay/:bookingId" element={<PublicAppointmentPaymentPage />} />
        <Route path="/receipt/:bookingId" element={<PublicAppointmentReceiptPage />} />
        <Route path="/s/:businessId" element={<BusinessPage />} />
        <Route path="/s/:businessId/:branchId" element={<BranchPage />} />
        <Route path="/:businessId" element={<BusinessPage />} />
        <Route path="/:businessId/:branchId" element={<BranchPage />} />
      </Routes>
      <Toaster />
    </ApolloProvider>
  );
}

export default App;
